// removed by extract-text-webpack-plugin
module.exports = {"ipad-portrait":"768px","mobile":"480px","mobile-l":"640px","white":"#ffffff","fastest":".15s","standard":"cubic-bezier(0.4, 0, 0.2, 1)","wrapper":"_2UEYsnzHBhfk0TaghPFmwO","videoBackground":"_26Ov3oW_UP6vuTaN1GiL2H","videoSrc":"_trND-z1re_a7T-sy_O8o","overlay":"_1H4Xc1BSY2OFiANUD2R3oc","pb01":"_2LFdBHMm2J_UJIrwqJI-RK","pb02":"_2WbxgRupGzwX9dkWM6PlFP","isPlaying":"_3F1K5P2QKK7cR3omMCKP8V"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Banner/HeroBanner/HeroWrapper/HeroWrapper.css
// module id = 1389
// module chunks = 0